module.exports = __webpack_public_path__ + "img/2001_L.456a5090.png";